export default __webpack_public_path__ + "../staticImages/rioja-260.png";